/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/ArrowDown.svg';
import { ReactComponent as TickIcon } from 'assets/icons/Tick_Thin.svg';
import { Colors } from 'styles';
import cx from 'classnames';
import { useOutsideClick } from 'hooks';
import styles from './DropdownBase.module.scss';

interface DropdownBaseItem {
  id: string | number;
  label: string | number;
  value: string | number;
}

interface DropdownBasePropsI {
  label?: string;
  values: Array<DropdownBaseItem>;
  value: DropdownBaseItem;
  onChange(element: DropdownBaseItem): void;
  closeOnClick?: boolean;
  fullWidth?: boolean;
  maxHeightList?: number;
}

const DropdownBase = (props: DropdownBasePropsI): JSX.Element => {
  const {
    maxHeightList = 30,
    fullWidth = false,
    label = 'Label',
    values = [],
    onChange,
    value,
    closeOnClick = true,
  } = props;
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setOpen(false));
  const toggleDropdown = () => {
    setOpen(!open);
  };
  return (
    <div ref={dropdownRef} className={cx(styles.root, { [styles.fullWidth]: fullWidth })}>
      <span className={styles.label}>{label}</span>
      <button onClick={() => toggleDropdown()} type="button" className={cx(styles.button, { [styles.open]: open })}>
        <span>{value.label}</span>
        <ArrowDownIcon height={12} width={12} fill={Colors.COLOR_GRAY_500} />
      </button>
      <ul style={{ maxHeight: `${maxHeightList}rem` }} className={cx(styles.list, { [styles.hide]: !open })}>
        {values.map((item) => (
          <li
            key={item.id}
            className={cx(styles.item, { [styles.active]: item.id === value.id })}
            onClick={(e) => {
              e.preventDefault();
              onChange(item);
              if (closeOnClick) {
                setOpen(false);
              }
            }}
          >
            <span>{item.label}</span>
            {item.id === value.id && <TickIcon />}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(DropdownBase);
